module.exports = __webpack_public_path__ + "img/logoDark.2f31c622.png";